<template>
  <div class="country-appointment-earlist-date" v-if="showEarliestBen">
    <div class="detail-btn" @click="onShowEarliestDate">
      查看预约日历
      <el-tooltip
        placement="right"
        content="*可预约时间仅供参考，详情请咨询签证专家"
        popper-class="new-visa-top-infos-tooltip"
      >
        <span class="tooltip-icon"></span>
      </el-tooltip>
    </div>
    <el-dialog
      title=""
      v-model="showDialog"
      custom-class="country-appointment-earlist-date-dialog"
      :show-close="false"
      top="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-box">
        <div class="dialog-header">
          <div class="header-title">最近可预约日期</div>
          <div class="header-close" @click="showDialog = false"></div>
        </div>
        <div class="dialog-body">
          <div class="country-info">
            <img class="country-flag" :src="earliestDateInfo.national_flag_img" alt="">
            <div class="country-name-box">
              <div class="country-name">{{earliestDateInfo.country_name}}</div>
              <div class="country-en-name">{{earliestDateInfo.en_country_name}}</div>
            </div>
          </div>
          <div class="earliest-tips">*可预约时间仅供参考，详情请咨询签证专家</div>
          <div class="earliest-date-table">
            <div class="table-header">
              <div class="th city is-center">使馆城市</div>
              <div class="th earliest">预约时间</div>
              <div class="th update">更新时间</div>
            </div>
            <div class="table-body">
              <div class="tr" v-for="(v, ind) in earliestDateInfo.appointment_list" :key="ind">
                <div class="td city is-center">{{v.city_name}}</div>
                <div class="td earliest">{{v.earliest_date ? formatDateWithzeroWithWeek(v.earliest_date) : '-'}}</div>
                <div class="td update">{{v.update_date ? formatDateWithoutYear(v.update_date) : ''}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

import dateUtils from '@/libs/date-util';
import Http from '@/libs/http';
import User from '@/libs/user';

export default {
  components: {},
  props: {
    countryId: {
      type: Number,
      required: true,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showDialog: false,
      earliestDateInfo: undefined,
    };
  },
  computed: {
    showEarliestBen() {
      return this.earliestDateInfo &&
        this.earliestDateInfo.appointment_list &&
        this.earliestDateInfo.appointment_list.some(v => v.earliest_date);
    },
  },
  created() {
    if (!User.isLogin()) return;
    this.getEarliestDateInfo();
  },
  methods: {
    formatDateWithoutYear: dateUtils.formatDateWithoutYear,
    formatDateWithWeek: dateUtils.formatDateWithWeek,
    formatDateWithzeroWithWeek: dateUtils.formatDateWithzeroWithWeek,
    getEarliestDateInfo() {
      return Http.post('/country_appointment_query', {
        visa_country_id: this.countryId,
      }).then((data) => {
        this.earliestDateInfo = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    onShowEarliestDate() {
      this.showDialog = true;
      sensorsdata.track('ProductBookCalendar', {
        visa_product_id: this.product.visa_product_id,
        product_name: this.product.product_name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.country-appointment-earlist-date{
  .detail-btn{
    color: #599FFF;
    cursor: pointer;
    margin-left: 8px;
    display: flex;
    align-items: center;
    .tooltip-icon{
      background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/icon-query.png) no-repeat center / 100% 100%;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      cursor: pointer;
    }
  }
}

/deep/ .country-appointment-earlist-date-dialog{
  width: 680px;
  transform: translate(-50%,-50%);
  box-shadow: 0px 8px 12px 0px rgba(57,61,70,0.06);
  border-radius: 4px;
  margin: 0;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
  }
  .dialog-box{
    .dialog-header{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      background-color: #2F333D;
      padding: 0 24px;
      .header-title{
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        font-weight: 600;
      }
      .header-close{
        cursor: pointer;
        width: 24px;    
        height: 25px;
        background: url(https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/earliest-date/icon-close.png) no-repeat center / 100% 100%;
      }
    }
    .dialog-body{
      padding: 24px;
      line-height: 1;
      .country-info{
        display: flex;
        align-items: flex-start;
        .country-flag{
          flex-shrink: 0;
          height: 40px;
          border: 1px solid #DEE2E6;
        }
        .country-name-box{
          margin-left: 12px;
          .country-name{
            font-size: 20px;
            font-weight: 600;
            color: #2F333D;
          }
          .country-en-name{
            font-size: 12px;
            color: #91999F;
            margin-top: 8px;
          }
        }
      }
      .earliest-tips{
        font-size: 12px;
        color: #91999F;
        margin-top: 24px;
      }
      .earliest-date-table{
        margin-top: 8px;
        border: 1px solid #DEE2E6;
        .th.city, .td.city{
          width: 164px;
          flex-shrink: 0;
        }
        .th.earliest, .td.earliest{
          width: 225px;
          flex-shrink: 0;
        }
        .th.update, .td.update{
          flex-grow: 1;
        }
        .table-header{
          display: flex;
          align-items: center;
          background-color: #F3F6F9;
          .th{
            height: 48px;
            display: flex;
            align-items: center;
            font-size: 16px;
            line-height: 22px;
            color: #2F333D;
            padding: 8px 20px;
            &.is-center{
              justify-content: center;
            }
          }
        }
        .table-body{
          .tr{
            display: flex;
            &:nth-child(even){
              background-color: #FAFBFC;
            }
            .td{
              min-height: 48px;
              font-size: 14px;
              line-height: 22px;
              color: #2F333D;
              display: flex;
              align-items: center;
              padding: 8px 20px;
              &.is-center{
                justify-content: center;
              }
            }
          }
        }
      }
      
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-top-infos-components/country-appointment-earliest-date.vue